var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phhonor-hea"},[_c('div',{staticClass:"phhonorhea-left"},[(_vm.$store.state.phLogoImage)?_c('img',{attrs:{"src":_vm.$store.state.phLogoImage}}):_vm._e()]),_c('div',{staticClass:"phhonorhea-right",on:{"click":_vm.navtomore}},[_c('img',{attrs:{"src":require("../assets/phaboutimg/phaboutmenu.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }